webpackJsonp([1],{

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    dataList: [],
    tableHeadings: ['Name', 'Position', 'Office', 'Age', 'Start date', 'Salary', 'Currency']
  },
  mutations: {
    setDataList: function setDataList(state, payload) {
      state.dataList = payload;
    }
  },
  actions: {
    getDataFromAPI: function getDataFromAPI(_ref) {
      var _this = this;

      var commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('clearError');
                commit('setLoading', true);
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.myjson.com/bins/vh9ms').then(function (response) {
                  commit('setLoading', false);
                  commit('setDataList', response.data);
                });

              case 5:
                _context.next = 12;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                commit('setLoading', false);
                commit('setError', _context.t0.message);
                throw _context.t0;

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 7]]);
      }))();
    }
  },
  getters: {
    getDataList: function getDataList(state) {
      return state.dataList;
    },
    getTableHeadings: function getTableHeadings(state) {
      return state.tableHeadings;
    }
  }
});

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: null
    };
  },
  props: {
    source: String
  },
  computed: {
    error: function error() {
      return this.$store.getters.error;
    },
    isUserLoggedIn: function isUserLoggedIn() {
      return this.$store.getters.isUserLoggedIn;
    },
    links: function links() {
      if (this.isUserLoggedIn) {
        return [{ title: 'Home', icon: 'home', url: '/' }, { title: 'List', icon: 'list', url: '/list' }];
      }
      return [{ title: 'Login', icon: 'lock', url: '/login' }];
    }
  },
  methods: {
    closeError: function closeError() {
      this.$store.dispatch('clearError');
    },
    onLogout: function onLogout() {
      this.$store.dispatch('logoutUser');
      this.$router.push('/');
    }
  }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  computed: {
    isUserLoggedIn: function isUserLoggedIn() {
      return this.$store.getters.isUserLoggedIn;
    }
  }
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: false,
      email: '',
      password: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return emailRegex.test(v) || 'E-mail must be valid';
      }],
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }, function (v) {
        return v && v.length >= 6 || 'Password must be equal or more than 6 characters';
      }]
    };
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var user = {
          email: this.email,
          password: this.password
        };

        this.$store.dispatch('loginUser', user).then(function () {
          _this.$router.push('/');
        }).catch(function () {});
      }
    }
  },
  created: function created() {
    if (this.$route.query.loginError) {
      this.$store.dispatch('setError', 'Please log in to access this page.');
    }
  }
});

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: false,
      email: '',
      password: '',
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }, function (v) {
        return v.length >= 6 || 'Password must be equal or more than 6 characters';
      }],
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return emailRegex.test(v) || 'E-mail must be valid';
      }]
    };
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var user = {
          email: this.email,
          password: this.password
        };

        this.$store.dispatch('registerUser', user).then(function () {
          _this.$router.push('/');
        }).catch(function () {});
      }
    }
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DataTable',
  data: function data() {
    return {
      showCounter: 10,
      page: 1,
      minValue: 0,
      searchQuery: '',
      sortKey: '',
      sortField: []
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('getDataFromAPI');
  },

  computed: {
    getDataCount: function getDataCount() {
      var _this = this;

      var dataList = this.$store.getters.getDataList;
      this.minValue = this.showCounter * (this.page - 1);
      if (this.searchQuery) {
        return dataList.slice(0, dataList.length).filter(function (person) {
          if (person.name.toLowerCase().indexOf(_this.searchQuery.toLowerCase()) !== -1) {
            return person;
          }
          return false;
        });
      }
      if (this.minValue > dataList.length) {
        this.page = this.getPageLength;
        this.minValue = this.showCounter * this.page - Math.floor(dataList.length / this.getPageLength);
      }
      return dataList.slice(this.minValue, this.showCounter * this.page);
    },
    getDataList: function getDataList() {
      return this.$store.getters.getDataList;
    },
    getTableHeadings: function getTableHeadings() {
      return this.$store.getters.getTableHeadings;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    getPageLength: function getPageLength() {
      return Math.floor(this.getDataList.length / this.showCounter);
    }
  },
  methods: {
    sortByKey: function sortByKey(key) {
      var data = this.getDataList;
      var result = [];
      var fieldName = null;

      if (key === 'Start date') {
        fieldName = 'start_date';
      } else {
        fieldName = key;
      }

      if (this.sortField.includes(key)) {
        var index = this.sortField.indexOf(fieldName);
        this.sortField.splice(index, 1);
        result = data.sort(function (a, b) {
          return b[fieldName.toLowerCase()] > a[fieldName.toLowerCase()] ? 1 : -1;
        });
        this.$store.commit('setDataList', result);
      } else {
        this.sortField.push(key);
        result = data.sort(function (a, b) {
          return b[fieldName.toLowerCase()] < a[fieldName.toLowerCase()] ? 1 : -1;
        });
        this.$store.commit('setDataList', result);
      }
    }
  }
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dataTable__ = __webpack_require__(133);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    shared: __WEBPACK_IMPORTED_MODULE_2__shared__["a" /* default */], user: __WEBPACK_IMPORTED_MODULE_3__user__["a" /* default */], dataTable: __WEBPACK_IMPORTED_MODULE_4__dataTable__["a" /* default */]
  }
}));

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(39);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  validations: {},
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>',
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_firebase__["initializeApp"]({
      apiKey: 'AIzaSyDVBRH2EIXwG1HU7cET46FzRk56ewNaziU',
      authDomain: 'vuejs-table-component.firebaseapp.com',
      databaseURL: 'https://vuejs-table-component.firebaseio.com',
      projectId: 'vuejs-table-component',
      storageBucket: 'vuejs-table-component.appspot.com',
      messagingSenderId: '682193045380'
    });
    __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch('autoLoginUser', user);
      }
    });
  }
});

/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302363bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(63);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_302363bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{staticClass:"hidden-md-and-up",attrs:{"app":"","temporary":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":"","three-line":""}},[_vm._l((_vm.links),function(link){return _c('v-list-tile',{attrs:{"to":link.url}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(link.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(link.title))])],1)],1)}),_vm._v(" "),(_vm.isUserLoggedIn)?_c('v-list-tile',{on:{"click":_vm.onLogout}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Logout")])],1)],1):_vm._e()],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"indigo","dark":"","fixed":"","app":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Data Table App")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},[_vm._l((_vm.links),function(link){return _c('v-btn',{attrs:{"flat":"","to":link.url}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n          "+_vm._s(link.icon)+"\n        ")]),_vm._v("\n        "+_vm._s(link.title)+"\n      ")],1)}),_vm._v(" "),(_vm.isUserLoggedIn)?_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.onLogout}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n          exit_to_app\n        ")]),_vm._v("\n        Logout\n      ")],1):_vm._e()],2)],1),_vm._v(" "),_c('v-content',[_c('keep-alive',[_c('router-view')],1)],1),_vm._v(" "),(_vm.error)?[_c('v-snackbar',{attrs:{"timeout":5000,"multi-line":true,"color":"error","value":true},on:{"input":_vm.closeError}},[_vm._v("\n      "+_vm._s(_vm.error)+"\n      "),_c('v-btn',{attrs:{"flat":"","dark":""},nativeOn:{"click":function($event){return _vm.closeError($event)}}},[_vm._v("Close")])],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Auth_Login__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Auth_Registration__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DataTable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_guard__ = __webpack_require__(90);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/list',
    name: 'list',
    component: __WEBPACK_IMPORTED_MODULE_5__components_DataTable__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_6__auth_guard__["a" /* default */]
  }, {
    path: '/registration',
    name: 'registration',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Auth_Registration__["a" /* default */]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Auth_Login__["a" /* default */]
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bfda5a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(80);
function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bfda5a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bfda5a6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 79:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isUserLoggedIn)?_c('h1',[_vm._v("\n    For authorization use the following data:\n    "),_c('div',[_vm._v("test@mail.ru")]),_vm._v(" "),_c('div',[_vm._v("123456")]),_vm._v(" "),_c('div',[_vm._v("or you can register")])]):_c('h1',[_c('span',[_vm._v("w")]),_vm._v(" "),_c('span',[_vm._v("e")]),_vm._v(" "),_c('span',[_vm._v("l")]),_vm._v(" "),_c('span',[_vm._v("c")]),_vm._v(" "),_c('span',[_vm._v("o")]),_vm._v(" "),_c('span',[_vm._v("m")]),_vm._v(" "),_c('span',[_vm._v("e")]),_vm._v(" "),_c('span',[_vm._v("😋")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(36);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76af3531_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(83);
function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76af3531_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 82:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Login form")])],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"validate":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"Email","label":"Email","type":"email","required":"","rules":_vm.emailRules},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"id":"password","prepend-icon":"lock","name":"password","label":"Password","type":"password","rules":_vm.passwordRules},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loading,"disabled":!_vm.valid || _vm.loading},on:{"click":_vm.onSubmit}},[_vm._v("Login")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","to":"/registration"}},[_vm._v("Register")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b48793_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__ = __webpack_require__(86);
function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b48793_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Registration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Register form")])],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"Email","label":"Email","type":"email","required":"","rules":_vm.emailRules},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"id":"password","prepend-icon":"lock","name":"password","label":"Password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loading,"disabled":!_vm.valid || _vm.loading},on:{"click":_vm.onSubmit}},[_vm._v("\n                Create account!\n              ")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af45ed5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__ = __webpack_require__(89);
function injectStyle (ssrContext) {
  __webpack_require__(88)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0af45ed5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DataTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af45ed5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DataTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',{attrs:{"fluid":"","xs12":"","sm12":"","md12":""}},[(_vm.loading)?[_c('v-progress-linear',{attrs:{"indeterminate":true}})]:(!_vm.getDataCount || _vm.getDataCount.length === 0)?[_c('h1',[_vm._v("No data :(")])]:[_c('div',{staticClass:"table-actions"},[_c('div',{staticClass:"show-counter"},[_c('label',{attrs:{"for":"counter"}},[_vm._v("Show")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showCounter),expression:"showCounter"}],staticClass:"show-input",attrs:{"type":"number","id":"counter","value":"10","min":"1","autofocus":""},domProps:{"value":(_vm.showCounter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.showCounter=$event.target.value}}}),_vm._v("\n                entries\n              ")]),_vm._v(" "),_c('div',{staticClass:"search"},[_c('label',{attrs:{"for":"search"}},[_vm._v("Search:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"search-input",attrs:{"type":"search","id":"search","placeholder":"search by name field"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',_vm._l((_vm.getTableHeadings),function(heading){return _c('th',{key:heading,on:{"click":function($event){_vm.sortByKey(heading)}}},[_vm._v("\n                  "+_vm._s(heading)+"\n                  "),_c('span',{staticClass:"arrow",class:_vm.sortField.includes(heading) ? 'asc' : 'dsc'})])}))]),_vm._v(" "),_c('tbody',_vm._l((_vm.getDataCount),function(data,index){return _c('tr',{key:index},[_c('td',[_vm._v("\n                  "+_vm._s(data.name)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(data.position)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(data.office)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(data.age)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(data.start_date)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(data.salary)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(data.currency)+"\n                ")])])}))]),_vm._v(" "),(!_vm.searchQuery)?_c('v-pagination',{attrs:{"length":_vm.getPageLength,"total-visible":"10"},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()]],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(39);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.user) {
    next();
  } else {
    next('/login?loginError=true');
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    error: null
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    setLoading: function setLoading(_ref, payload) {
      var commit = _ref.commit;

      commit('setLoading', payload);
    },
    setError: function setError(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setError', payload);
    },
    clearError: function clearError(_ref3) {
      var commit = _ref3.commit;

      commit('clearError');
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);





var User = function User(id) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, User);

  this.id = id;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    registerUser: function registerUser(_ref, _ref2) {
      var _this = this;

      var commit = _ref.commit;
      var email = _ref2.email,
          password = _ref2.password;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit('clearError');
                commit('setLoading', true);
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_firebase__["auth"]().createUserWithEmailAndPassword(email, password);

              case 5:
                user = _context.sent;

                commit('setUser', new User(user.uid));
                commit('setLoading', false);
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](2);

                commit('setLoading', false);
                commit('setError', _context.t0.message);
                throw _context.t0;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 10]]);
      }))();
    },
    loginUser: function loginUser(_ref3, _ref4) {
      var _this2 = this;

      var commit = _ref3.commit;
      var email = _ref4.email,
          password = _ref4.password;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit('clearError');
                commit('setLoading', true);
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_firebase__["auth"]().signInWithEmailAndPassword(email, password);

              case 5:
                user = _context2.sent;

                commit('setUser', new User(user.uid));
                commit('setLoading', false);
                _context2.next = 15;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](2);

                commit('setLoading', false);
                commit('setError', _context2.t0.message);
                throw _context2.t0;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 10]]);
      }))();
    },
    autoLoginUser: function autoLoginUser(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setUser', new User(payload.uid));
    },
    logoutUser: function logoutUser(_ref6) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_3_firebase__["auth"]().signOut();
      commit('setUser', null);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    isUserLoggedIn: function isUserLoggedIn(state) {
      return state.user !== null;
    }
  }
});

/***/ })

},[60]);


// WEBPACK FOOTER //
// static/js/app.11323ab433084c95ac61.js